import axios from "axios";
import qs from "qs";
import pkceChallenge from "pkce-challenge";
import { getExpiryTimeAsString, isExpired } from "./tokenUtils";
import { TokenResponse } from "./types";

function getToken(
  code: string,
  authUrl: string,
  redirectUrl: string,
  clientId: string
): Promise<TokenResponse> {
  return axios
    .post(
      `${authUrl}/as/token.oauth2`,
      qs.stringify({
        grant_type: "authorization_code",
        code: code,
        client_id: clientId,
        code_verifier: sessionStorage.getItem("verify"),
        redirect_uri: redirectUrl,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then(({ data }) => data);
}

function redirectCallback(
  redirectUrl: string,
  clientId: string,
  authUrl: string,
  scope?: string
): void {
  const url = getAuthUrl(
    redirectUrl || window.location.origin,
    clientId,
    authUrl,
    scope || "openid profile email address groups"
  );
  return window.location.assign(url);
}

function getAuthUrl(
  redirectUrl: string,
  clientId: string,
  authUrl: string,
  scope?: string
): string {
  const { code_challenge, code_verifier } = pkceChallenge();

  sessionStorage.setItem("verify", code_verifier);
  sessionStorage.setItem(
    "original_location",
    window.location.pathname + window.location.search
  );

  const url = `${authUrl}/as/authorization.oauth2?response_type=code&redirect_uri=${redirectUrl}&code_challenge=${code_challenge}&code_challenge_method=S256&client_id=${clientId}`;

  if (scope) {
    return `${url}&scope=${scope}`;
  }

  return url;
}

const refreshToken = (
  authUrl: string,
  redirectUrl: string,
  clientId: string
): void => {
  const expiryDate = sessionStorage.getItem("expiry") || "";

  const refreshToken = sessionStorage.getItem("refresh_token") || "";

  if (isExpired(+expiryDate) && refreshToken !== "" ) {
    axios
      .post(
        `${authUrl}/as/token.oauth2`,
        qs.stringify({
          grant_type: "refresh_token",
          refresh_token: refreshToken,
          client_id: clientId,
          redirect_uri: redirectUrl,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then(({ data }) => {
        sessionStorage.setItem("refresh_token", data.refresh_token);
        sessionStorage.setItem("token", data.access_token);
        sessionStorage.setItem(
          "expiry",
          getExpiryTimeAsString(data.expires_in)
        );
      });
  }
};
export { getToken, refreshToken, redirectCallback };